import Rpc from "@/Rpc";
import SessionManager from "@/utils/SessionManager";
import ConfigManager, {SCOPE_USER} from "@/utils/ConfigManager";
import superagent from 'superagent';
import RpcClass from "@/server/RpcClass";
import EventBus from "@/utils/EventBus";

export let STANDALONE_ON_LOCAL = true;

export async function checkLocalConfig(){
    if(window.location.href.includes("localhost")){
        STANDALONE_ON_LOCAL = !(await Rpc.Session.paymentsEnabled());
        if(!STANDALONE_ON_LOCAL){
            console.warn("STANDALONE_ON_LOCAL = false");
        }
    }
}
export function isLocalStandalone(){
    return (window.location.href.includes("localhost") ||
            window.location.href.includes("demo.silkplm.com") ||
            window.location.href.includes("cert.silkplm.com") ||
            window.location.hostname.match(/^a\d+.*$/)
        )
        && STANDALONE_ON_LOCAL;
}

export function checkPreselectedPlan() {
    const url = new URL(window.location.href);
    const planId = new URLSearchParams(url.search).get("plan-id");
    if (!planId) {
        localStorage.removeItem('preselectedPlan');
        return;
    }

    localStorage.setItem('preselectedPlan', planId);
}

export function getPreselectedPlan() {
    return localStorage.getItem("preselectedPlan");
}

async function getPortalLink(){
    let linkData = await Rpc.Subscriptions.paymentPortalLink();

    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open('POST', linkData.server + "/wp-json/custom-api/v1/login", true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.withCredentials = true;
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
                console.log('Success:', xhr.responseText);
                resolve(linkData);
            } else {
                console.error('Error:', xhr.statusText);
                reject(xhr.statusText);
            }
        };
        let data = "token=" + encodeURIComponent(linkData.token);
        xhr.send(data);
    });
}
export async function openSubscriptionPanel(){
    let linkData = await getPortalLink();
    window.open(linkData.server + "/my-account/subscriptions/", '_blank');
}

export async function loginToWp(){
    return await getPortalLink();
}

export async function buyPlan(planId, linkData){
    let link = `/?add-to-cart=${planId}&auto-checkout=1`;
    window.open(linkData.server + link);
}

export async function openAddSubscriptionPage(){
    let linkData = await getPortalLink();
    window.open(linkData.server + "/shop", '_blank');
}

export async function rememberAutoConf(userInfo){
    let configManager = new ConfigManager();
    await configManager.preload();
    let autoConf = localStorage.getItem("autoconf") ?? "";
    console.log("XXXXXXXX")
    await configManager.save("tour.autostart.autoconf", autoConf, SCOPE_USER, userInfo.applicationUser.id);
}

export async function postSignup(){
    let plan = getPreselectedPlan();
    await SessionManager.configManager?.save("tour.autostart.preselectedPlan", plan, SCOPE_USER);
    let linkData = await getPortalLink();

    // zezwolenie na konta free
    // if(!plan){
    //     return false;
    // }

    if(!plan || plan === "choose"){
        //window.location.replace(linkData.server + "/choose-plan");
        window.location.replace("/designer-plan/");

    } else {
        window.location.replace(linkData.server + "/?add-to-cart=" + plan + "&auto-checkout=1");
    }
    return true;
}

function brokerServer(){
    if(window.location.href.includes("localhost")){
        return "http://127.0.0.1:5002";
    }
    return "https://subscribe.silkplm.com"
}

let regionsList = null;
export async function listRegions(){
    if(isLocalStandalone()){
        regionsList = [{"id": 1, "name": "Localhost", "servers": [{name:
                    (window.location.hostname === "demo.silkplm.com" || window.location.hostname === "cert.silkplm.com") ?
                window.location.hostname :
                window.location.hostname + ":8443"}
            ]}];
        return regionsList;
    }

    if(regionsList){
        return regionsList;
    }
    const regions = await superagent.get(brokerServer() + "/regions-broker/pub/regions/all"); // Replace with your desired URL
    console.log("Available regions:" + JSON.stringify(regions));
    regionsList = regions.body;
    return regionsList;
}

export function switchRegion(regionId){
    for(let region of regionsList){
        if(region.id === regionId){
            let server = region.servers[0];
            window["_apiEndpoint"] = "https://" + server.name;
            RpcClass.baseAddress = "https://" +  server.name;
            localStorage.setItem("_apiEndpoint", window["_apiEndpoint"]);

            window["_wsEndpoint"] = "wss://" + server.name;
            localStorage.setItem("_wsEndpoint", window["_wsEndpoint"]);

            EventBus.$emit(Events.endpointUpdated, currentRegion());
            return;
        }
    }
}

export function currentRegion(){
    if(RpcClass.baseAddress){
        return RpcClass.baseAddress.replace("https://", "").replace(".silkplm.com", "");
    } else {
        return window.location.hostname.replace(".silkplm.com", "");
    }
}

export function switchServer(server){
    window["_apiEndpoint"] = "https://" + server;
    window["_wsEndpoint"] = "wss://" + server;
    RpcClass.baseAddress = "https://" +  server;

    localStorage.setItem("_apiEndpoint", window["_apiEndpoint"]);
    localStorage.setItem("_wsEndpoint", window["_wsEndpoint"]);
    EventBus.$emit(Events.endpointUpdated, currentRegion());
}

window['_switchServer'] = switchServer;

export function saveLastLoginServer(){
    localStorage.setItem("_apiEndpoint", window["_apiEndpoint"]);
    localStorage.setItem("_wsEndpoint", window["_wsEndpoint"]);
}

let backupEndpoint = "";
let backupBaseAddress = "";
let backupWsEndpoint = "";

export function restoreLastLoginServer(){
    let lastEndpoint = localStorage.getItem("_apiEndpoint");
    let lastWsEndpoint = localStorage.getItem("_wsEndpoint");

    if(lastEndpoint && !lastEndpoint.includes("undefined")){
        backupEndpoint = window["_apiEndpoint"];
        backupWsEndpoint = window["_wsEndpoint"];
        backupBaseAddress = RpcClass.baseAddress;

        window["_apiEndpoint"] = lastEndpoint;
        if(lastWsEndpoint) {
            window["_wsEndpoint"] = lastWsEndpoint;
        } else {
            window["_wsEndpoint"] = lastEndpoint.replace("https://", "wss://");
        }
        RpcClass.baseAddress = window["_apiEndpoint"];
    }
}
export function resetEndpoint(){
    window["_apiEndpoint"] = backupEndpoint;
    window["_wsEndpoint"] = backupWsEndpoint;
    RpcClass.baseAddress = backupBaseAddress;
    localStorage.removeItem("_apiEndpoint");
    localStorage.removeItem("_wsEndpoint");
}


export async function getAvailableUserConnections(email){
    if(isLocalStandalone()){
        let orgs = await Rpc.Session.orgsByEmail(email);
        let serverName =
            (window.location.hostname === "demo.silkplm.com" || window.location.hostname === "cert.silkplm.com") ?
                window.location.hostname :
                window.location.hostname + ":8443";
        if(!orgs.length){
            return {"server_name": serverName}
        }

        let result = [];

        for(let orgName of orgs){
            result.push({
                name: orgName,
                server_name: serverName
            })
        }
        return {
            organizations: result
        }
    }

    const connections = await superagent.get(brokerServer() + "/regions-broker/pub/users/organizations/email").
        query({email}); // Replace with your desired URL

    console.log("Available connections:" + JSON.stringify(connections));
    return connections.body;
}